(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_79f7848"] && !Shopify.designMode) return;
  try {
    (function() {
  function buildToc() {
    var col = document.querySelector('.ai-blog-layout-content-column-{{ ai_gen_id }}');
    var w = document.getElementById('widget');
    if (!col || !w) return;
    var heads = col.querySelectorAll('h2, h3');
    if (!heads.length) {
      var tc = w.closest('.ai-blog-layout-toc-column-{{ ai_gen_id }}');
      if (tc) tc.style.display = 'none';
      return;
    }
    var ul = document.createElement('ul');
    ul.className = 'ai-toc-list';
    heads.forEach(function(h, i) {
      if (!h.id) h.id = 'toc-h-' + i;
      h.style.scrollMarginTop = '110px';
      var li = document.createElement('li');
      li.className = h.tagName === 'H3' ? 'ai-toc-h3' : 'ai-toc-h2';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function(e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      li.appendChild(a);
      ul.appendChild(li);
    });
    w.appendChild(ul);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else { buildToc(); }
})();
  } catch(e) { console.error(e); }
})();

})();
